module.exports = __webpack_public_path__ + "img/knight-full.e9ce4877.png";